import { useContext } from 'react'
import { ThemeContext } from './ThemeContext'
import type { Theme, ResolvedTheme, FontSize } from './ThemeContext'

export function useTheme() {
  return useContext(ThemeContext)
}

export type { Theme, ResolvedTheme, FontSize }
